export default "__VITE_ASSET__BnBfkibP__"